// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__yGGBO","disabled":"card_disabled__gzqUh","target":"card_target__FQQ4D"};